import React from "react";
import "../styles/Footer.css";
// import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">

        {/* Quick Links */}
        <div className="footer-col">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/brands">Brands</a></li>
            <li><a href="/products">Products</a></li>
            <li><a href="/about">About Us</a></li>
            <li><a href="/contact">Contact Us</a></li>
          </ul>
        </div>

        {/* OEM Brands */}
        <div className="footer-col">
  <h3>Top Products</h3>
  <ul>
    <li><a href="/Z9">Mechanical Spare Parts</a></li>
    <li><a href="/Z2">AC Tools & Accessories</a></li>
    <li><a href="/Z5">Pneumatics</a></li>
    <li><a href="/Z12">Electronic Repairs</a></li>
    <li><a href="/Z10">Safety & PPE'S</a></li>
    <li><a href="/products">VIEW ALL</a></li>
  </ul>
</div>

        {/* Official Info */}
        <div className="footer-col">
          <h3>Official Information</h3>
          <p><strong>Registered Office:</strong><br/>
            CITY SURVEY NO.12229, QAYYUM APARTMENT,<br/>
            NANDED, MAHARASHTRA, INDIA, 431602

          </p>
          <p><strong>Call Us Now:</strong><br/>
            +919309318892<br/>
           
          </p>
          <p><strong>Email Us:</strong><br/>
          <p>aadil@zrknex.com</p>
                 
          </p>
        </div>
      </div>

      {/* Social Icons */}
      <div className="footer-bottom">
        {/* <div className="social-icons">
          <a href="https://facebook.com" aria-label="Facebook"><FaFacebookF /></a>
          <a href="https://instagram.com" aria-label="Instagram"><FaInstagram /></a>
          <a href="https://twitter.com" aria-label="Twitter"><FaTwitter /></a>
          <a href="https://linkedin.com" aria-label="LinkedIn"><FaLinkedinIn /></a>
        </div> */}
        <p>© {new Date().getFullYear()} zrknex All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
